<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2 ><v-icon large class="mr-2">mdi-tooltip-account</v-icon>{{ $t('administration.user.updatemypassword')}}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          color="primary"
          @click="cancel"
        >
          {{ $t('global.cancel')}}
        </v-btn>
        <v-btn
          class="ml-2"
          color="primary"
          @click="updatePassword"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div>
      <v-container>
        <v-row>
          <v-col md="12">
            <PasswordUpdateForm class="ml-2" ref="PasswordUpdateForm" :values="item" :errors="violations" />
          </v-col>
        </v-row>
        <Loading :visible="isLoading" />
      </v-container>
    </div>
    </v-sheet>

  </v-container>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState } from 'vuex';
import PasswordUpdateForm from '../../components/login/PasswordUpdate.vue';
import Loading from '../../components/Loading';
import NotificationMixin from '../../mixins/NotificationMixin';

const servicePrefix = 'User';
const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField'
});

export default {
  name: 'UpdatePassword',
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    PasswordUpdateForm
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations']),
    ...mapState('user', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    })
  },
  data() {
    return {
      item: {}
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: `Profil` });
    },
    updatePassword() {

      const PasswordUpdateForm = this.$refs.PasswordUpdateForm;
      PasswordUpdateForm.$v.$touch();
      if (!PasswordUpdateForm.$v.$invalid) {
        this.userPushAction({action: 'edit/password',values: {'oldPassword' :PasswordUpdateForm.$v.item.$model.oldPassword, 'plainPassword' : PasswordUpdateForm.$v.item.$model.plainPassword}});
      } else {
        console.log('error');
      }
    },
    ...mapActions({
      userPushAction: 'user/action'
    }),

    updatedPassword(item) {
      console.log("updatedPassword");
      this.$router.push({ name: `Profil` });
      this.showMessage(item.message);
    },

  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'edit/password') {
        this.updatedPassword(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
